import React from "react";
import {
  IPromoCityLevelPageProps,
  ICustomerPageState,
} from "../../../interfaces/Index";
import HeadingText from "../../common/HeadingText/HeadingText";
import AddUpdatePromosCityLevelPage from "./AddUpdatePromosCityLevelPage";
import PromosCityLevelList from "./PromosCityLevelList";
import AddBulkPromosCityLevelPage from "./AddBulkPromosCityLevelPage";
import { IPageType } from "interfaces/userLevelPromo.interface";
import DeactivateBulkPromoPage from "./DeactivateBulkPromoPage";

export default class aPromosPage extends React.Component<
  IPromoCityLevelPageProps,
  ICustomerPageState
> {
  constructor(props: IPromoCityLevelPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      showAddUpdatePage: false,
      pageType: "list",
      selectedPromo: null,
      isPromoAddUpdate: false,
      searchText: "",
      currentListPosition: 0,
      selectedCity: "",
      currentLocation: "",
    };
  }

  renderAddUpdatePromosPage = () => {
    const { isEdit, selectedPromo } = this.state;
    let props: any;
    const {
      isLoading,
      isError,
      error,
      createPromo,
      uploadUserLevelPromoCsv,
      createUploadUserLevelPromoCsv,
      isUserLevelPromoCsvLoading,
      isUserLevelPromoCsvUploaded,
      isUserLevelPromoCsvError,
      userLevelPromoCsvError,
      userLevelPromoCsvFile,
      userLevelPromoCsvFileName,
      history,
      location,
      match,
      isPromoAdded,
      promoDetails,
      isPromoDetailsFetched,
      fetchPromoDetails,
      clearPromoDetails,
      isPromoUpdated,
      updatePromoStatus,
      createBasketPromo,
      createBasketLevel,
      getPromoByType,
      isPromoByTypeFetched,
      isPromoByTypeFetchError,
      promosByType,
      typePromo,
      getCommandoCategories,
      commandoProductCategories,
      citiesList,
      fetchCities,
      isCityListFetched,
      getUCByCityId,
      getWarehouseByCityId,
      warehouseList,
      isWarehouseFetched,
      promoId,
      promoDescription,
      ucList,
      isUcFetched,
      fetchCustomerConfig,
      customerConfig,
      updatePromo,
    } = this.props;
    const { selectedCity } = this.state;
    return (
      <AddUpdatePromosCityLevelPage
        promo={selectedPromo}
        isEdit={isEdit}
        backButtonHandler={this.navigateBackToListingPage}
        isLoading={isLoading}
        isError={isError}
        error={error}
        updatePromoStatus={updatePromoStatus}
        updatePromo={updatePromo}
        createPromo={createPromo}
        isPromoAdded={isPromoAdded}
        history={history}
        location={location}
        match={match}
        promoDetails={promoDetails}
        isPromoDetailsFetched={isPromoDetailsFetched}
        fetchPromoDetails={fetchPromoDetails}
        clearPromoDetails={clearPromoDetails}
        isPromoUpdated={isPromoUpdated}
        createBasketPromo={createBasketPromo}
        createBasketLevel={createBasketLevel}
        getPromoByType={getPromoByType}
        isPromoByTypeFetched={isPromoByTypeFetched}
        isPromoByTypeFetchError={isPromoByTypeFetchError}
        promosByType={promosByType}
        typePromo={typePromo}
        getCommandoCategories={getCommandoCategories}
        commandoProductCategories={commandoProductCategories}
        selectedCity={selectedCity}
        citiesList={citiesList}
        fetchCities={fetchCities}
        isCityListFetched={isCityListFetched}
        getUCByCityId={getUCByCityId}
        getWarehouseByCityId={getWarehouseByCityId}
        ucList={ucList}
        warehouseList={warehouseList}
        promoId={promoId}
        promoDescription={promoDescription}
        isWarehouseFetched={isWarehouseFetched}
        isUcFetched={isUcFetched}
        uploadUserLevelPromoCsv={uploadUserLevelPromoCsv}
        createUploadUserLevelPromoCsv={createUploadUserLevelPromoCsv}
        isUserLevelPromoCsvLoading={isUserLevelPromoCsvLoading}
        isUserLevelPromoCsvUploaded={isUserLevelPromoCsvUploaded}
        isUserLevelPromoCsvError={isUserLevelPromoCsvError}
        userLevelPromoCsvError={userLevelPromoCsvError}
        userLevelPromoCsvFile={userLevelPromoCsvFile}
        userLevelPromoCsvFileName={userLevelPromoCsvFileName}
        customerConfig={customerConfig}
        fetchCustomerConfig={fetchCustomerConfig}
        {...props}
      />
    );
  };

  renderPromosListing = () => {
    let props: any;
    const {
      promosCityLevel,
      isFetchPromosLoading,
      isFetchPromosError,
      error,
      pagination,
      isPromoAdded,
      isPromoUpdated,
      fetchPromos,
      citiesList,
      fetchCities,
      isCityListFetched,
    } = this.props;
    const {
      isPromoAddUpdate,
      searchText,
      currentListPosition,
      selectedCity,
      currentLocation,
    } = this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Promo" isMainHeading={true} />
        </section>
        <PromosCityLevelList
          fetchPromos={fetchPromos}
          promosCityLevel={promosCityLevel}
          pagination={pagination}
          isLoading={isFetchPromosLoading}
          isError={isFetchPromosError}
          error={error}
          isPromoAddedorUpdated={isPromoAddUpdate}
          currentLocation={currentLocation}
          isPromoAdded={isPromoAdded}
          isPromoUpdated={isPromoUpdated}
          addUpdatePageHandler={this.togglePromosPage}
          retainedSearchText={searchText}
          currentListPosition={currentListPosition}
          selectedCity={selectedCity}
          citiesList={citiesList}
          fetchCities={fetchCities}
          isCityListFetched={isCityListFetched}
          {...props}
        />
      </>
    );
  };

  renderAddBulkPromosPage = () => {
    const { isEdit } = this.state;
    let props: any;
    const {
      isLoading,
      isError,
      error,
      createUserLevelPromoBulk,
      isPromoAdded,
      clearPromoDetails,
    } = this.props;
    const { selectedCity } = this.state;
    return (
      <AddBulkPromosCityLevelPage
        isPromoAdded={isPromoAdded}
        clearPromoDetails={clearPromoDetails}
        isEdit={isEdit}
        backButtonHandler={this.navigateBackToListingPage}
        isLoading={isLoading}
        isError={isError}
        error={error}
        createUserLevelPromoBulk={createUserLevelPromoBulk}
        selectedCity={selectedCity}
        {...props}
      />
    );
  };

  renderBulkDeactivatePromosPage = () => {
    const { isEdit } = this.state;
    let props: any;
    const {
      isLoading,
      isError,
      error,
      deactivateUserLevelPromoBulk,
      isPromoUpdated,
      clearPromoDetails,
    } = this.props;
    const { selectedCity } = this.state;
    return (
      <DeactivateBulkPromoPage
        isPromoUpdated={isPromoUpdated}
        clearPromoDetails={clearPromoDetails}
        isEdit={isEdit}
        backButtonHandler={this.navigateBackToListingPage}
        isLoading={isLoading}
        isError={isError}
        error={error}
        deactivateUserLevelPromoBulk={deactivateUserLevelPromoBulk}
        selectedCity={selectedCity}
        {...props}
      />
    );
  };

  togglePromosPage = (
    selectedCity: object = {},
    pageType: IPageType = { type: "list" },
    isEdit: boolean = false,
    selectedPromo: any = null,
    searchText: string = "",
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      pageType: pageType.type,
      isEdit: isEdit,
      selectedPromo: selectedPromo,
      searchText: searchText,
      currentListPosition: currentScroll,
      selectedCity: selectedCity,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean, currentLocation: any) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      pageType: "list",
      showAddUpdatePage: !showAddUpdatePage,
      isPromoAddUpdate: isAddUpdate,
      searchText: isAddUpdate ? "" : searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
      currentLocation: currentLocation,
    });
  };

  renderPageType({ type }: IPageType) {
    switch (type) {
      case "single":
        return this.renderAddUpdatePromosPage();
      case "bulk":
        return this.renderAddBulkPromosPage();
      case "bulk-deactivate":
        return this.renderBulkDeactivatePromosPage();
      default:
        return this.renderPromosListing();
    }
  }
  render() {
    const { pageType } = this.state;
    return <div>{this.renderPageType({ type: pageType })}</div>;
  }
}
